/* eslint-disable no-shadow */
import { Point } from '../geom/Point';
import { Modifiers } from './Modifiers';
import { WheelUtil } from './WheelUtil';

export enum WheelDevice {
    Mouse = 0,
    Trackpad = 1,
}

export enum WheelGesture {
    Drag = 0,
    Pinch = 1,
}

export class WheelInput {

    public static fromEvent(e: WheelEvent, relativeElmt: HTMLElement) {
        const info = WheelUtil.inspect(e);
        return new WheelInput(
            info.source === 'trackpad' ? 1 : 0,
            Point.from(e, 'delta'),
            Point.from(e, 'client').subtract(relativeElmt.getBoundingClientRect()),
            (e.ctrlKey || e.metaKey || info.hints.pinch) ? 1 : 0,
            Modifiers.fromEvent(e),
        );
    }

    private constructor(
        public readonly device: WheelDevice,
        public readonly delta: Point,
        public readonly position: Point,
        public readonly gesture: WheelGesture,
        public readonly modifiers: Modifiers,
    ) { }
}
